import { AxiosService } from '../../../utils/axiosService';

import Config from '../../../config';

const login = async data => await AxiosService.post( Config.securityApi + 'login', data, false);


export default {
    login
}